module.exports = __webpack_public_path__ + "assets/8e424ae0f29664c95b3f1be671bc905b.png";